import React from 'react';
import Sidebar from '../components/Sidebar';
import { FileText, Lock } from 'lucide-react';

const Terms = () => (
  <div className="flex h-screen bg-slate-50/50 font-inter text-blue-900 overflow-hidden">
    <Sidebar />
    <main className="flex-1 p-12 overflow-y-auto">
      <div className="max-w-3xl bg-white p-16 rounded-[3rem] border border-slate-100 shadow-sm">
        <header className="mb-12">
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 bg-blue-600 text-white rounded-2xl">
              <FileText size={24} />
            </div>
            <h1 className="text-3xl font-black italic uppercase tracking-tighter">
              Terms of <span className="text-blue-600">Service</span>
            </h1>
          </div>
          <p className="text-slate-400 text-xs font-black uppercase tracking-widest">User Agreement & Data Sovereignty</p>
        </header>

        <div className="space-y-10">
          <div className="grid grid-cols-2 gap-6">
            <div className="p-6 bg-blue-50/50 rounded-2xl border border-blue-100">
              <Lock className="text-blue-600 mb-3" size={20} />
              <h3 className="text-[10px] font-black uppercase mb-2">Data Sovereignty</h3>
              <p className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">All audit results are stored locally. We do not transmit client risk profiles to external servers.</p>
            </div>
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-100">
              <FileText className="text-slate-400 mb-3" size={20} />
              <h3 className="text-[10px] font-black uppercase mb-2">Usage License</h3>
              <p className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Active subscription grants a non-exclusive license to use the Protection Engine for internal compliance.</p>
            </div>
          </div>

          <div className="border-t border-slate-50 pt-10 space-y-6">
            <section>
              <h2 className="text-[11px] font-black uppercase tracking-widest text-blue-900 mb-2">1. Subscription Billing</h2>
              <p className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Billing is recurring. Users may cancel via Settings. Access remains active until the end of the current billing cycle.</p>
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
);

export default Terms;